import React, { useMemo, useState } from "react";
import { MdPreview } from "md-editor-rt";
import { Collapse, message } from "antd";
import { ReactComponent as LineIcon } from "../static/line_icon.svg";
import downIcon from "../static/down.svg";
import deepseekThinkIcon from "../static/deepseek_think.svg";
import "md-editor-rt/lib/style.css";
// import "md-editor-rt/lib/preview.css";
import FileItem from "./fileitem";
import "./theme.css";

interface Props {
  className?: string;
  props: any;
}
const Markdown: React.FC<Props> = ({ props }) => {
  // console.log("🚀 ~ Markdown ~ props:", props, props.refText && !props.prompts);
  const [id] = useState("preview-only");
  const [refTextHeight, setRefTextHeight] = useState<boolean>(false);

  return (
    <>
      {props.role === "user" ? (
        <div className="flex justify-end ">
          {props.content &&
            !props.prompts &&
            !props.refText &&
            (!props.fileList || props?.fileList?.length === 0) && (
              <p className="bg-[rgb(238,241,255)] rounded-[8px] px-[12px] py-[6px] w-auto whitespace-pre-wrap text-theme">
                {props.content}
              </p>
            )}
          {props.prompts && (
            <div className="max-w-full flex flex-col items-end">
              <div className="bg-[#EEF1FF] w-[fit-content] rounded-[8px] float-right p-[6px] my-[14px] max-w-full flex items-center gap-[4px] ">
                {props?.prompts?.icon && (
                  <img
                    src={props?.prompts?.icon}
                    className="w-[14px] h-[14px]"
                  />
                )}
                <p className="m-0 text-[14px] text-[#000000f5]">
                  {props?.prompts?.content}
                </p>
              </div>
              {props.prompts.type === "image" ? (
                <div className="flex justify-end max-w-full flex-wrap gap-[6px]">
                  {props.prompts.fileList.map((item: any, index: number) => {
                    return (
                      <div
                        key={index}
                        className="max-h-[128px] max-w-[346px] relative group gap-[6px]"
                      >
                        <img
                          src={item.url}
                          className="max-h-[128px] max-w-[346px]"
                          alt=""
                          style={{
                            border: "1px solid #e6e6e6",
                            padding: "4px",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : props.prompts.type === "file" ? (
                <div className="flex max-w-full flex-wrap  gap-[6px] justify-end">
                  {props.prompts.fileList.map((file: any, index: number) => {
                    const fileExtension = file?.name?.split(".").pop() || "";
                    if (
                      [
                        "doc",
                        "docx",
                        "xls",
                        "xlsx",
                        "ppt",
                        "pptx",
                        "txt",
                        "pdf",
                      ].includes(fileExtension)
                    ) {
                      return (
                        <FileItem
                          key={index}
                          url={file.url}
                          fileName={file.name}
                          fileType={fileExtension}
                          img_obj={file}
                          isMessage={true}
                          onGetItem={() => {
                            // urlTofile(file);
                          }}
                        />
                      );
                    }
                    return null; // 如果不符合条件，返回 null
                  })}
                </div>
              ) : props.prompts.refText ? (
                <div
                  className={`px-[12px] py-[10px] min-h-[40px] max-w-[250px] w-[fit-content]  rounded-[8px] overflow-hidden  cursor-pointer   hover:!border-[#72768b52]`}
                  style={{
                    border: "1px solid #72768b29",
                    height: refTextHeight ? "auto" : "40px",
                  }}
                  onClick={() => {
                    setRefTextHeight((pre: boolean) => {
                      return !pre;
                    });
                  }}
                >
                  <p
                    className={`m-0  w-[100%] text-[#0a0d3373] text-[12px] ${
                      !refTextHeight &&
                      "text-ellipsis whitespace-nowrap  overflow-hidden "
                    }`}
                  >
                    {props.prompts.refText}
                  </p>
                </div>
              ) : null}
            </div>
          )}
          {props.refText && !props.prompts && (
            <div className="flex justify-end flex-col items-end gap-[14px]">
              <p className="bg-[rgb(238,241,255)] rounded-[8px]  px-[12px] py-[6px] w-fit whitespace-pre-wrap text-theme">
                {props.content}
              </p>
              <div
                className={`px-[12px] py-[10px] min-h-[40px] max-w-[250px] w-[fit-content]  rounded-[8px] overflow-hidden  cursor-pointer   hover:!border-[#72768b52]`}
                style={{
                  border: "1px solid #72768b29",
                  height: refTextHeight ? "auto" : "40px",
                }}
                onClick={() => {
                  setRefTextHeight((pre: boolean) => {
                    return !pre;
                  });
                }}
              >
                <p
                  className={`m-0  w-[100%] text-[#0a0d3373] text-[12px] ${
                    !refTextHeight &&
                    "text-ellipsis whitespace-nowrap  overflow-hidden "
                  }`}
                >
                  {props.refText}
                </p>
              </div>
            </div>
          )}
          {props?.fileList?.length > 0 && (
            <div className="flex justify-end flex-col items-end gap-[14px]">
              <p className="bg-[rgb(238,241,255)] rounded-[8px]  px-[12px] py-[6px] w-fit whitespace-pre-wrap text-theme">
                {props.content}
              </p>
              <div className="flex gap-[10px] ">
                {props.fileList.map((item: any, index: number) => {
                  if (
                    ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(
                      item.name.split(".").pop()
                    )
                  ) {
                    return (
                      <div
                        key={index}
                        className="max-h-[128px] max-w-[346px] relative group gap-[6px]"
                      >
                        <img
                          src={item.url}
                          className="max-h-[128px] max-w-[346px]"
                          alt=""
                          style={{
                            border: "1px solid #e6e6e6",
                            padding: "4px",
                            borderRadius: "8px",
                          }}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <FileItem
                        key={index}
                        url={item.url}
                        fileName={item.name}
                        fileType={item.name.split(".").pop() || ""}
                        img_obj={item}
                        isMessage={true}
                        onGetItem={() => {
                          // urlTofile(file);
                        }}
                      />
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      ) : props?.imgUrlList ? (
        <div className="flex gap-[10px] max-w-[100%]">
          {!props.errorCode && !props.error && (
            <img
              src={props.modelLogo}
              alt="模型头像"
              className="w-[30px] h-[30px]"
            />
          )}

          <div className="flex flex-col gap-[12px] overflow-hidden">
            <div>
              <p className="font-bold text-[#333333] text-[16px] h-[30px] leading-[30px]">
                {props.modelName}
              </p>
              <div className="p-[5px] rounded-[8px] flex justify-center items-center   gap-[12px] max-w-full">
                {props.imgUrlList.map((item: any) => {
                  return (
                    <img
                      src={item}
                      alt=""
                      className="min-w-[132px] min-h-[132px] rounded-[8px]  max-w-full"
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex gap-[10px] max-w-[100%]">
          {!props.errorCode && !props.error && (
            <img
              src={props.compareArray[props.arrNum || 0].modelLogo}
              alt="模型头像"
              className="w-[30px] h-[30px]"
            />
          )}

          <div className="flex flex-col gap-[12px] overflow-hidden">
            {!props.errorCode && !props.error && (
              <div>
                <p className="font-bold text-[#333333] text-[16px] h-[30px] leading-[30px]">
                  {props.compareArray[props.arrNum || 0].modelName}
                </p>
              </div>
            )}

            {props.compareArray[props.arrNum || 0].searchResults &&
              props?.compareArray[props.arrNum || 0]?.searchResults?.length >
                0 && (
                <Collapse
                  ghost
                  items={[
                    {
                      key: "deep-searchResults",
                      label: (
                        <div className=" flex gap-[4px] group items-center mb-[8px]">
                          <LineIcon className="text-[#333333] w-[16px] h-[16px] group-hover:hidden" />
                          <img
                            src={downIcon}
                            alt=""
                            className="w-[16px] h-[16px]  hidden group-hover:flex"
                          />
                          <p className="m-0 text-[#0a0d3373] text-[14px] font-semibold group-hover:text-[#0a0d3399]">
                            已搜索到
                            {
                              props.compareArray[props.arrNum || 0]
                                .searchResults?.length
                            }
                            个网页
                          </p>
                        </div>
                      ),
                      className: "aiPreThink aiPreSearch",
                      children: (
                        <ul className="p-0 m-0  grid grid-cols-2 gap-x-[2%] gap-y-[8px] ">
                          {props.compareArray[
                            props.arrNum || 0
                          ].searchResults.map((item: any) => (
                            <li
                              key={item.index}
                              className="max-h-[26px] h-[26px] overflow-hidden flex bg-[#72768b0f] px-[12px] items-center gap-[4px] rounded-full cursor-pointer text-[12px] hover:bg-[#72768b1f]"
                              style={{
                                width: "100%",
                                maxWidth: "100%",
                              }}
                              onClick={() => {
                                // chrome.tabs.create({ url: item.url });
                                window.open(item.url, "_blank");
                              }}
                            >
                              {item.icon ? (
                                <img
                                  src={item.icon}
                                  className="w-[16px] h-[16px] mr-1 flex-shrink-0"
                                  alt="图标"
                                />
                              ) : (
                                <LineIcon className="text-[#333333] w-[16px] h-[16px] mr-1 flex-shrink-0" /> // 固定图标尺寸
                              )}
                              <p className="m-0 text-ellipsis overflow-hidden whitespace-nowrap flex-grow">
                                {item.title}
                              </p>
                            </li>
                          ))}
                        </ul>
                      ),
                      showArrow: false,
                    },
                  ]}
                />
              )}
            {props.compareArray[props.arrNum || 0].deepThinkingContent && (
              <Collapse
                ghost
                items={[
                  {
                    key: "deep-think",
                    label: (
                      <div className=" flex gap-[4px] group items-center mb-[8px]">
                        <img
                          className="w-[16px] h-[16px] group-hover:hidden"
                          src={deepseekThinkIcon}
                          alt="深度思考"
                        />
                        <img
                          src={downIcon}
                          className="w-[16px] h-[16px]  hidden group-hover:flex"
                          alt=""
                        />
                        <p className="m-0 text-[#0a0d3373] text-[14px] font-semibold group-hover:text-[#0a0d3399]">
                          已深度思考（用时
                          {Math.ceil(
                            (props.compareArray[props.arrNum || 0]
                              .thinkingTimeEnd -
                              props.compareArray[props.arrNum || 0]
                                .thinkingTimeStart) /
                              1000
                          )}
                          秒）
                        </p>
                      </div>
                    ),
                    className: "aiPreThink",
                    children: (
                      // <Markdown previewTheme="deep-think">
                      //   {item.deepThinkingContent}
                      // </Markdown>
                      <MdPreview
                        previewTheme={"deepThink"}
                        id="preview-only"
                        autoFoldThreshold={10000000}
                        value={
                          props.compareArray[props.arrNum || 0]
                            .deepThinkingContent
                        }
                      />
                    ),
                    showArrow: false,
                  },
                ]}
              />
            )}
            <MdPreview
              previewTheme={"text"}
              id={id}
              value={props.compareArray[props.arrNum || 0].content}
              autoFoldThreshold={10000000}
            ></MdPreview>
          </div>
        </div>
      )}
    </>
  );
};

export default Markdown;
